<script setup>
</script>
<template>
  <div class="container">
    <div style="max-width:760px; font-size: 16px; padding: 0 12px;">
        <h3 class="mt-4"> Bokettersyn og kontrollbesøk av Skatteetaten </h3>
        <p class="mt-4">
          Hvis Skatteetaten oppsøker foretaket ditt i forbindelse med bokettersyn eller kontrollbesøk, kan revisor be deg om ulike opplysninger.
        </p>

        <h4 class="mt-5 mb-3"> Elektronisk journal </h4>
        <p>
          Elektronisk journal er en obligatorisk funksjon for kassesystem, som logger alle salgstransaksjoner i et SAF-T-format. SAF-T er et skjema med standardiserte formater for overlevering av regnskap- og kassasystemdata.
          Skjemaet skal benyttes når Skatteetaten i forbindelse med kontroll, ber om å få fremlagt den elektroniske journalen på standardisert form fastsatt av <a href="https://www.skatteetaten.no/rettskilder/type/kunngjoringer/standard-format-for-eksport-av-elektronisk-journal/">Skattedirektoratet</a>.
        </p>
        <p>
          For å hente ut dette skjemaet, går du til Rapporter --> SAF-T rapport og velg hvilket kassepunkt rapporten gjelder for. Skjemaet sendes da til e-postadressen din.
        </p>
        <p class="mt-5">
          <img src="@/assets/images/saft-report.png" style="max-width:100%; height:auto;" alt="SAF-T rapport" />
        </p>

        <h4 class="mt-5 mb-3"> Z-rapport </h4>
        <p>
          Z-rapport er en rapport for dagsoppgjør for et kassepunkt. Rapportene finner du ved å gå til <a href="https://backoffice.cagista.com/z-report">Rapporter --> Z-rapport</a>. Velg kassepunkt og dato rapporten gjelder for og klikk på "Vis Z-rapport".
          Du kan eksportere og lagre Z-rapporter som PDF for å skrive dem ut om det er nødvendig.
        </p>
        <p class="mt-5">
          <img src="@/assets/images/z-report.png" style="max-width:100%; height:auto;" alt="Z-rapport" />
        </p>

        <h4 class="mt-5 mb-3"> Kassesystemets modellbetegnelse og versjonsnummer </h4>
        <p>
          Opplysninger om modell, type og versjon av kassasystemet, med ID-nummeret til kassesystemet finner du på PIN-innloggingsvinduet i TastyPOS appen.
        </p>
        <p class="mt-5">
          <img src="@/assets/images/id_nummer.png" style="max-width:100%; height:auto;" alt="ID nummer" />
        </p>

        <h4 class="mt-5 mb-3"> Opplysninger på kvittering </h4>
        <p class="mb-5">
          Kassesystemets ID-nummer vises på alle kvitteringer. Det er obligatoriske opplysninger som viser at kvitteringen er en kassesystemkvittering.
          Ved betaling med kontant skrives det ut automatisk en salgskvittering. I appen kan du også skrive ut kopikvitteringer.
        </p>

    </div>
  </div>
</template>